import { render, staticRenderFns } from "./DisplayType.vue?vue&type=template&id=79b697b9&scoped=true&"
import script from "./DisplayType.vue?vue&type=script&lang=ts&"
export * from "./DisplayType.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayType.vue?vue&type=style&index=0&id=79b697b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b697b9",
  null
  
)

export default component.exports